export default __webpack_public_path__ + "static/media/icon_about_privacy.685bd171.svg";